import { styled } from '@mui/system';
import { Box, TextField } from '@mui/material';

export const PinStepContainer = styled(Box)({
  padding: '40px 30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#000000',
  borderRadius: '32px',
  width: '100%',
  gap: '20px',
  boxSizing: 'border-box',
});

export const LogoContainer = styled(Box)({
  marginBottom: '20px',
});

export const PinInputContainer = styled(Box)({
  display: 'flex',
  padding: '0px 10px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '6px',
  flex: '1 0 0',
});

export const StyledPinInput = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    border: '2px solid var(--Separators-Non-opaque---Dark, rgba(84, 84, 88, 0.65))',
    background: 'rgba(120, 120, 128, 0.36)',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '41px',
    letterSpacing: '-0.4px',
    fontFeatureSettings: "'liga' off, 'clig' off",
  },
  '& .MuiOutlinedInput-input': {
    textAlign: 'center',
    color: '#FFFFFF',
    fontFamily: '"SF Pro Display", Arial, sans-serif',
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '41px',
    letterSpacing: '-0.4px',
    fontFeatureSettings: "'liga' off, 'clig' off",
    padding: '4px 0',
    background: 'transparent',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});

export const HelpTextContainer = styled(Box)({
  marginTop: '20px',
  textAlign: 'center',
  padding: '0 40px',
});

